import { Box, Button, CircularProgress, Stack, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import TaskSummaryForm from './TaskSummaryForm'
import { isEqual } from 'lodash'
import ToastAlert from 'components/core/Layouts/ToastAlert'
import SideDialog from 'components/pages/dis/components/SideDialog'

function TaskSummarySettingsDialog({
	defaultTileWidth,
	tileElementWidth,
	settings,
	isSubmitting,
	open,
	tile,
	showStable,
	onClose,
	onSubmit,
	dashboardKeyList,
	onResizeTileWidth,
	menuKeyInUrl,
	taskMapSettingTypes,
}) {
	const [t] = useTranslation('common')
	const [alertInfo, setAlertInfo] = useState({
		open: false,
		text: '',
		type: 'success',
	})
	const dialogWidth = tile?.w ?? 6
	const STABLE_WIDTH = 6

	const [filterData, setFilterData] = useState(settings || {})

	useEffect(() => {
		if (isEqual(filterData, settings)) return
		setFilterData(settings)
	}, [settings])

	const handleSettingsChange = (name, value) => {
		setFilterData((prev) => ({
			...prev,
			[name]: value,
		}))
	}

	const handleCloseDialog = () => {
		setFilterData(settings)
		onClose()
	}

	const handleSubmit = () => {
		onSubmit?.({
			filterField: filterData?.filterField,
			statusField: filterData?.statusField,
			progressBarField: filterData?.progressBarField,
			modalDashboardSetting: filterData?.modalDashboardSetting,
			selectedTaskMapForm: filterData?.selectedTaskMapForm,
			taskMapAddressField: filterData?.taskMapAddressField,
			taskMapDatePreset: filterData?.taskMapDatePreset,
			taskMapBubbleFields: filterData?.taskMapBubbleFields,
		})
	}

	return (
		<>
			<ToastAlert alertInfo={alertInfo} setAlertInfo={setAlertInfo} />

			<SideDialog
				defaultTileWidth={defaultTileWidth}
				open={open}
				onClose={onClose}
				width={showStable ? STABLE_WIDTH : dialogWidth}
				tileElementWidth={tileElementWidth}
				onResizeWidth={onResizeTileWidth}
			>
				<Stack
					sx={{
						'& .MuiInputBase-input': {
							fontSize: '0.9rem !important',
						},
						'& .MuiCheckbox-root': {
							p: 0,
						},
					}}
				>
					<Box sx={{ px: 1 }}>
						<TextField
							fullWidth
							id="label-basic"
							variant="standard"
							value={tile.i}
							disabled={true}
							size="small"
						/>
					</Box>
					<Box sx={{ px: 1, mt: 2 }}>
						<TaskSummaryForm
							isSubmitting={isSubmitting}
							filterData={filterData}
							onFilterDataChange={handleSettingsChange}
							taskMapSettingTypes={taskMapSettingTypes}
							tileType={tile?.type}
						/>
					</Box>
					<Stack direction="row" justifyContent="flex-end" mt={2}>
						<Stack spacing={2} direction="row">
							<Button
								size="small"
								variant="contained"
								onClick={handleSubmit}
								disabled={isSubmitting}
								startIcon={isSubmitting ? <CircularProgress color="inherit" size="1em" /> : null}
							>
								{t('common:misc.ok')}
							</Button>
							<Button size="small" variant="text" onClick={handleCloseDialog}>
								{t('common:misc.cancel')}
							</Button>
						</Stack>
					</Stack>
				</Stack>
			</SideDialog>
		</>
	)
}

export default TaskSummarySettingsDialog
